import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { MultilineText } from 'utils/renderMultilineText';
import styles from './AlertModalPaywaySucces.module.scss';
import {
  renderArrayMaxLength,
  renderMaxLengthText,
} from 'utils/renderMaxLengthText';

export default function AlertModalPaywaySucces({
  open,
  type = 'success',
  onClose,
  closeOnOverlay = true,
  onAutoClose,
  messageArg = [],
  gateway = 'claropagosgate',
}) {
  const assets = useSelector(state => state.asset);
  const paymentMethodsExperienceConfigByRegion = useSelector(
    selectMetadataKeyByRegion('payment_method_modals_config'),
  );

  const { modal_add_confirmation_seconds, modal_update_confirmation_seconds } =
    paymentMethodsExperienceConfigByRegion || {};

  let keyForSecondsToUse;

  switch (type) {
    case 'successUpdate':
      keyForSecondsToUse = modal_update_confirmation_seconds;
      break;

    case 'success':
      keyForSecondsToUse = modal_add_confirmation_seconds;
      break;
  }

  const timeToShowModal = (keyForSecondsToUse || 3) * 1000;

  const successIcon = assets?.Icono_Correcto || '';
  const newArray = renderArrayMaxLength(messageArg, 65);

  useEffect(
    () => {
      if (!open) return;

      const timer = setTimeout(() => {
        onClose?.();
        onAutoClose?.();
      }, timeToShowModal);

      return () => clearTimeout(timer);
    },
    [open, timeToShowModal, onClose],
  );

  if (!open) return null;

  return (
    <div
      className={styles.overlay}
      onClick={closeOnOverlay ? onClose : () => {}}
    >
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.iconContainer}>
          {successIcon ? (
            <img className={styles.icon} src={successIcon} />
          ) : (
            <span className={styles.icon} />
          )}
        </div>

        <div
          className={`${styles?.content_message} ${
            type === 'successUpdate' ? styles?.successUpdate : ''
          }`}
          data-gateway={gateway}
        >
          {newArray?.map((text, index) => {
            if (index === 0 && type === 'success')
              return (
                <p
                  className={`${styles?.message} ${styles.stronge}`}
                >{`${text} `}</p>
              );
            return <p className={`${styles?.message}`}>{text}</p>;
          })}
        </div>
      </div>
    </div>
  );
}
